module.exports = __webpack_public_path__ + "img/gibraltar.c2dc7201.svg";